export type Objective = 'TestObjective' | 'Recover Abandoned Sales' | 'Ensure Legislative Compliance';

const OffsiteObjectiveList: Objective[] = ['Recover Abandoned Sales'];
const MPSObjectiveList: Objective[] = ['Ensure Legislative Compliance'];

const description: { [o in Objective]: string } = {
  TestObjective: 'objectives.testObjective.description',
  'Recover Abandoned Sales': 'objectives.recoverAbandonedSales.description',
  'Ensure Legislative Compliance': 'objectives.ensureLegislativeCompliance.description',
};

const titles: { [o in Objective]: string } = {
  TestObjective: 'objectives.testObjective.title',
  'Recover Abandoned Sales': 'objectives.recoverAbandonedSales.title',
  'Ensure Legislative Compliance': 'objectives.ensureLegislativeCompliance.title',
};

export const objectiveIconMap: { [feat in Objective]?: string } = {
  'Recover Abandoned Sales': 'cart-arrow-down',
  'Ensure Legislative Compliance': 'handshake-alt',
};

const getMPSObjectives = (): Objective[] => MPSObjectiveList;
const getOffsiteObjectives = (): Objective[] => OffsiteObjectiveList;
const getDescription = (obj: Objective): string => description[obj];
const getIcon = (feature: Objective): string => objectiveIconMap[feature] || 'clipboard-check';
const getTitle = (obj: Objective): string => titles[obj];

export const Objectives = {
  getMPSObjectives,
  getOffsiteObjectives,
  getDescription,
  getTitle,
  getIcon,
};
